var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('tippy',{attrs:{"content":`<strong>This video has a framerate of ${_vm.fps} fps.</strong> Videos above 30 fps are billed at a multiple of the base price. <a href='/faq#higher-framerates'>Learn more</a>`,"interactive":true}},[_c('i',{staticClass:"fas fa-info-circle"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }